<!-- <div mat-dialog-title class="confirmHeader p-2 d-flex justify-content-center">
    <img src="../../../../assets/icons/user_icons/warning.svg" alt="Warning" class="material-icons md-48">
</div> -->
<div class="d-flex justify-content-center" *ngIf="data.header && data.header !='Extraction Procedure'"><h1 class="header m-0">{{data.header}}</h1></div>
<span class="migrate_wrap">
    <div mat-dialog-content>
        <span [innerText]="data.alert" class="message"></span>
        <span [innerText]="data.message" class="message"></span>
    </div>
</span>

<div mat-dialog-actions class="confirm_dia d-flex justify-content-center" [ngStyle]="{'justify-content': data.cancel === 'dontshow' ? 'center':''}">

 
    <app-button  buttonclass="primary" class="popup-btn mr-2" customClass="admin" (click)="returnResponse('Save and Proceed')">Save and Proceed</app-button>
    <app-button  buttonclass="primary" class="mr-2 popup-btn" customClass="admin" (click)="returnResponse('Proceed without Saving')" mat-dialog-close >Proceed without Saving</app-button>
    <app-button buttonclass="primary" class="popup-btn" customClass="admin" (click)="returnResponse('Stay in this Page')" mat-dialog-close>Stay in this Page</app-button>
    
</div>